import { useRef } from 'react';
import { tokens, container, dragHandle } from './atom.progress-bar.style.js';
import { useDragHandle } from './hook.drag-handle.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Progressbar(props) {
  const containerRef = useRef(null);
  const wasPlayingBeforeDragRef = useRef(props.isPlaying);
  const onDragBegin = () => {
    wasPlayingBeforeDragRef.current = props.isPlaying;
    props.pause();
  };
  const onDragEnded = progress => {
    props.seek(progress * props.durationMs);
    if (wasPlayingBeforeDragRef.current) {
      props.resume();
    }
  };
  const onKeyDown = evt => {
    switch (evt.key) {
      case "Enter":
      case " ":
        if (props.isPlaying) {
          props.pause();
        } else {
          props.resume();
        }
        break;
      case "ArrowLeft":
        props.seek(Math.max(0, props.progress * props.durationMs - props.durationMs * 0.05));
        break;
      case "ArrowRight":
        props.seek(Math.min(props.progress * props.durationMs + props.durationMs * 0.05, props.durationMs));
        break;
    }
  };
  const [isDragging, dragHandlePosition] = useDragHandle(containerRef, {
    onDragBegin,
    onDragEnded
  });
  const currentProgress = isDragging ? dragHandlePosition : props.progress;
  return /*#__PURE__*/jsx("div", {
    ref: containerRef,
    className: container,
    style: tokens.filled.__override(currentProgress),
    children: /*#__PURE__*/jsxs("button", {
      className: dragHandle,
      style: tokens.dragHandleOffset.__override(`${currentProgress * 100}%`),
      onKeyDown: onKeyDown,
      "aria-label": "S\xF8g i lydfil",
      "aria-description": "S\xF8g i lydfil ved brug af venstre- og h\xF8jre-piletasterne",
      children: [/*#__PURE__*/jsx("span", {
        "data-thumb": true
      }), /*#__PURE__*/jsx("span", {
        "data-outline": true
      })]
    })
  });
}

export { Progressbar };
//# sourceMappingURL=atom.progress-bar.js.map
